import React from 'react';
import { ShieldCheck, Star, CalendarCheck2, MapPin } from 'lucide-react';

export default function TrustRow({ className = '' }) {
  const items = [
    { icon: ShieldCheck, label: 'Fully Insured' },
    { icon: Star, label: '4.9± Google Reviews' },
    { icon: CalendarCheck2, label: 'Same-Week Availability' },
    { icon: MapPin, label: 'Serving 5 Counties' },
  ];
  return (
    <div className={`flex flex-wrap items-center gap-x-5 gap-y-3 ${className}`}>
      {items.map(({ icon: Icon, label }) => (
        <div key={label} className="flex items-center gap-2 text-xs sm:text-sm text-slate-700">
          <span className="inline-flex items-center justify-center h-7 w-7 rounded-full bg-[#FBF7EE] border border-[#EED7A6]">
            <Icon className="h-3.5 w-3.5 text-[#C8922F]" />
          </span>
          <span className="font-medium">{label}</span>
        </div>
      ))}
    </div>
  );
}
